import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import {
  ChatBubbleOutlineOutlined as MessageIcon,
  PushPinOutlined as PinIcon,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import LeadActionsMenu from "../../../components/LeadActionsMenu";
import TemperatureChip from "../../../components/TemperatureChip";

// Área de ações do header, compartilhada pelo card normal e pelo colapsado:
// temperatura (ícone), chat, e o menu de ações (que também concentra "ver cliente").
// Os handlers de negócio vêm do próprio `lead` (amarrados em Leads.List.js) —
// só a trava de duplo-clique (isPending/fireAction/stop) é passada à parte, por
// ser estado local do card, não dado do lead.
const LeadCardHeaderActions = ({
  lead,
  pendingAction,
  isPending,
  fireAction,
  stop,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      {lead.isPinned && (
        <Tooltip title={t("leads.pinned")}>
          <span>
            <IconButton
              aria-label={t("leads.pinned")}
            >
              <PinIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      )}

      <TemperatureChip
        iconOnly
        hasInsight={lead.hasInsight}
        temperature={lead.temperature}
        temperatureValue={lead.temperatureValue}
        temperatureColor={lead.temperatureColor}
      />

      <LeadActionsMenu
        lead={lead}
        pendingAction={pendingAction}
        disabled={isPending}
        iconSize="medium"
        coloredIcons={false}
        onViewContact={lead.onLeadDetails}
        onAccept={fireAction(lead.onAccept)}
        onRelease={fireAction(lead.onRelease)}
        onClose={fireAction(lead.onClose)}
        onReopen={fireAction(lead.onReopen)}
        onTransfer={lead.onTransfer}
        onPin={fireAction(lead.onPin)}
        onUnpin={fireAction(lead.onUnpin)}
        onFavorite={fireAction(lead.onFavorite)}
        onUnfavorite={fireAction(lead.onUnfavorite)}
        onManageLists={lead.onManageLists}
        onPreview={() => navigate(`/leads/${lead.uuid}/preview`)}
      />
    </>
  );
};

export default LeadCardHeaderActions;
